import { Product } from "features/ProductReel/types";
import React, { useMemo, useState } from "react";
import styled from "styled-components/macro";
import { device, toRem } from "theme/Breakpoints";
import { colors } from "theme/Theme";
import {
  sectionsConfigType,
  SectionTitleEnum,
} from "features/productDetails/types";
import ProductDescription from "./components/ProductDescription";
import Reviews from "./components/Reviews";
import TechnicalInfo from "./components/TechnicalInfo";
import { DefaultText, shadow } from "theme/GlobalElements";
import { reviewsMock } from "./types";
import ProductDescriptionText from "./components/ProductDescriptioText";

interface ProductMoreInfoProps {
  fetchedProduct: Product;
}

const ProductMoreInfo: React.FC<ProductMoreInfoProps> = ({
  fetchedProduct,
}) => {
  const [activeSection, setActiveSection] = useState<string>(
    SectionTitleEnum.technicalInfo
  );

  const onSectionClick = (sectionTitle: string) => {
    setActiveSection(sectionTitle);
  };

  const sectionsConfig: sectionsConfigType = useMemo(() => {
    return {
      [SectionTitleEnum.technicalInfo]: {
        title: fetchedProduct.tech_specs.title,
        showTitle: true,
        component: <TechnicalInfo data={fetchedProduct.tech_specs} />,
      },
      [SectionTitleEnum.description]: {
        title: "Описание",
        showTitle:
          fetchedProduct.description.text !== undefined &&
          fetchedProduct.description.text !== "",
        component: (
          <ProductDescriptionText text={fetchedProduct.description.text} />
        ),
      },
      [SectionTitleEnum.functions]: {
        title: "Екстри",
        showTitle: fetchedProduct.extras.length > 0,
        component: <ProductDescription extras={fetchedProduct.extras} />,
      },
      // [SectionTitleEnum.reviews]: {
      //   title: "Отзиви",
      //   component: <Reviews reviews={reviewsMock} />,
      // },
    };
  }, []);

  return (
    <div>
      <ProductMoreInfoContainer>
        <Sections>
          <Title className="text-md">И още за продукта</Title>
          <SectionItems>
            {Object.values(SectionTitleEnum).map((item: string) => {
              const isActive = activeSection === item;

              return (
                sectionsConfig[item].showTitle && (
                  <SectionItem
                    key={item}
                    onClick={() => onSectionClick(item)}
                    className={isActive ? "active" : ""}
                  >
                    {sectionsConfig[item].title}
                  </SectionItem>
                )
              );
            })}
          </SectionItems>
        </Sections>
        <SectionsContent>
          {sectionsConfig[activeSection].component}
        </SectionsContent>
      </ProductMoreInfoContainer>
    </div>
  );
};

const ProductMoreInfoContainer = styled.div`
  margin: 30px 0;
  padding: 0 20px;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto auto;
  grid-row-gap: 10px;

  @media only screen and (${device.laptop}) {
    grid-template-columns: 1fr 3fr;
    grid-column-gap: 12px;
    grid-template-rows: 1fr;
  }

  @media only screen and (${device.laptopL}) {
    grid-template-columns: 1fr 4fr;
    grid-template-rows: 1fr;
    grid-column-gap: 10px;
  }
`;
ProductMoreInfoContainer.displayName = "ProductMoreInfoContainer";

const Sections = styled.div`
  background-color: ${colors.dark};
  padding-top: 10px;

  @media only screen and (${device.tablet}) {
    ${shadow}
  }
`;
Sections.displayName = "Sections";

const Title = styled(DefaultText)`
  width: 100%;
  text-align: center;
  color: white;
  font-weight: 600;
`;
Title.displayName = "Title";

const SectionItems = styled.div`
  margin-top: 10px;
`;
SectionItems.displayName = "SectionItems";

const SectionItem = styled(DefaultText)`
  padding: 10px 10px;
  background-color: ${colors.darkest_gray};
  color: white;

  & + & {
    margin-top: 2px;
  }

  &.active {
    color: white;
    background-color: ${colors.light_blue};
  }
`;
SectionItem.displayName = "SectionItem";

const SectionsContent = styled.div`
  width: 100%;
`;
SectionsContent.displayName = "SectionsContent";
export default ProductMoreInfo;
